<div class="dialog-title" *ngIf="formType == formTypeRequest.ADD">Assign Discount</div>
<div class="dialog-title" *ngIf="formType == formTypeRequest.EDIT">Edit Assigned Discount</div>

<div class="dialog-description" *ngIf="formType == formTypeRequest.ADD">
  Select discount and assign to this project.
</div>

<div class="dialog-description" *ngIf="formType == formTypeRequest.EDIT">
  Edit Effective and End Date.
</div>

<form [formGroup]="formGrp">
  <div class="form-field">
    <div class="info-container" fxLayout="row wrap">
      <div fxFlex="100">
        <mat-form-field>
          <mat-label>Select Discount</mat-label>
          <mat-select formControlName="discountId">
            <mat-option *ngFor="let option of discountOptions; let i = index" (click)="patchIntegrateSystemDate(i)" value={{option.id}}>{{option.title}}</mat-option>
          </mat-select>
          <mat-error>Discount is required</mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" class="left">
        <mat-form-field>
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="start" (click)="start.open()" required formControlName="effectiveDate" />
          <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
          <mat-datepicker #start></mat-datepicker>
          <mat-error>Start date is required</mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50">
        <mat-form-field>
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="end" (click)="end.open()" required formControlName="expiredDate" />
          <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
          <mat-datepicker #end></mat-datepicker>
          <mat-error>End date is required</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>

<div class="form-field" fxLayout="row wrap"></div>

<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" (click)="onSubmit()">Assign</button>
</div>